<template lang="pug">
    b-container.pt-3
      h4 Customers
      b-card.mt-3
        p Registered customers
        .row
          .col-md-6
            b-form
              b-form-group
                b-input-group(size='sm')
                  b-form-input#filterInput(v-model='filter', type='search', placeholder='Type to Search')
                  b-input-group-append
                    b-button(:disabled='!filter', @click="filter = ''") Clear
        content-loader(v-if="!customers", :height="7")
        b-table(v-else="", hover, :filter="filter", :items="customers", :fields="fields", fixed)
          template(v-slot:cell(name)='row') {{ `${row.item.firstname} ${row.item.lastname}` }}
</template>

<script>

import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'app',
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      filter: null,
      customers: null,
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'email', label: 'Email' },
        { key: 'phone', label: 'Phone' },
        // { key: 'orders', label: 'Orders Placed', sortable: true },
      ],
    };
  },
  computed: {
  },
  methods: {
  },
  async mounted() {
    this.customers = await apiService.getCustomers();
  },
};
</script>

<style lang="scss">
  .b-table{
  @media(max-width: 768px){
      font-size: 12px;
      td{
        padding: 5px !important;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Customers.vue